import { Box, Typography } from "@mui/material";
import { RuleFolderOutlined } from "@mui/icons-material";

/**
 * StandardsCallout — neat gray fill box for AISC / ISO / standards chapter-and-verse
 * call-outs. Mirrors the MUI Alert shape (icon + body) but in a quiet gray so clause
 * citations read as reference notes, not warnings. System-wide standards-citation style.
 *
 * Usage:
 *   <StandardsCallout>AISC 303 §1.7.0 — detailing must be customer-approved before release.</StandardsCallout>
 *   <StandardsCallout icon={false} dense sx={{ mt: 1 }}>D-032 §5.2 · PDF §15.2 release gate</StandardsCallout>
 */
export default function StandardsCallout({ children, icon = true, dense = false, per = true, sx = {} }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        bgcolor: "#F4F5F7",
        border: "1px solid #E3E6EA",
        borderRadius: 1.5,
        px: dense ? 1.25 : 2,
        py: dense ? 0.75 : 1.25,
        ...sx,
      }}
    >
      {icon && (
        <RuleFolderOutlined sx={{ fontSize: dense ? 16 : 18, color: "#6B7280", mt: "1px", flexShrink: 0 }} />
      )}
      <Typography
        variant="body2"
        sx={{
          color: "#4B5563",
          lineHeight: 1.5,
          fontSize: dense ? "0.78rem" : "0.82rem",
          "& code": {
            bgcolor: "#E5E7EB",
            px: 0.5,
            py: "1px",
            borderRadius: 0.5,
            fontSize: "0.85em",
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
          },
          "& strong": { color: "#374151", fontWeight: 700 },
        }}
      >
        {per ? "per " : ""}{children}
      </Typography>
    </Box>
  );
}
